<div class="main-layout">
  <div class="header">
    <app-header [navigationElement]="navigationElement" [contentElement]="contentElement"></app-header>
  </div>
  <div class="navigation" #navigationElement>
    <app-navigation></app-navigation>
  </div>
  <div class="content-wrapper" #contentElement>
    <app-nag></app-nag>
    <div class="content">
      <ng-container [ngSwitch]="loadingService.loadingState">
        <app-informative-page [informativePageData]="loadingService.informativePageData"
                              *ngSwitchCase="LoadingState.Info"></app-informative-page>
        <app-failed-page *ngSwitchCase="LoadingState.Failed"></app-failed-page>
        <app-loading-page *ngSwitchCase="LoadingState.Loading"></app-loading-page>
        <router-outlet *ngSwitchDefault></router-outlet>
      </ng-container>
    </div>
  </div>
</div>
